module.exports = __webpack_public_path__ + "static/media/market_grey.75717107.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/market_grey.svg
// module id = 595
// module chunks = 20